<template>
  <NetbarSoftware/>
</template>
<script>
import NetbarSoftware from 'place/management/netbarSoftware.vue'
export default {
    components:{
      NetbarSoftware
    }
}
</script>